// One shared grammar for local diary commands and the server's food-input guard.
const word = pattern => new RegExp(`(?<!\\p{L})(?:${pattern})(?!\\p{L})`, "giu");
const actions = { move: "перенеси(?:те)?|перенести|переноси(?:те)?|переносить|перемести(?:те)?|переместить", copy: "скопируй(?:те)?|скопировать|копируй(?:те)?|копировать|продублируй(?:те)?|продублировать" };

export const mealTransferRules = {
  id: "transfer-whole-meal",
  prompt: "Перенеси всю еду на вчера: все сохранённые блюда открытого приёма дописываются к целевому приёму без пересчёта и удаляются из исходного одной транзакцией. Скопируй мне завтрак со вчера: вчерашний завтрак дописывается в открытый приём, исходные блюда остаются. Скопируй всю еду на сегодня: копия открытого приёма добавляется в сегодняшний. Вчера и сегодня отсчитываются от текущей локальной даты; предыдущий день — от открытой даты. Будущие дни не поддерживаются. Без названия приёма сохраняется тип открытого приёма. Без даты используется открытый день. Одинаковый источник и назначение отклоняются без изменений. Существующая еда назначения сохраняется, похожие названия не заменяются. Неоднозначная, отрицательная или частичная команда не изменяет записи.",
};

export const isMealTransferCommand = text => word(Object.values(actions).join("|")).test(String(text));

export function parseMealTransferCommand(text) {
  if (!isMealTransferCommand(text)) return null;
  let rest = String(text).toLocaleLowerCase("ru-RU").replace(/ё/gu, "е");
  let direction = "to";
  let missingDirection = false;
  const readDirection = (input, index) => {
    const preposition = input.slice(0, index).match(/(?:^|\s)(со?|из|на|в)\s*$/u)?.[1];
    if (!preposition) missingDirection = true;
    else direction = ["с", "со", "из"].includes(preposition) ? "from" : "to";
  };
  const modes = [];
  for (const [mode, pattern] of Object.entries(actions)) rest = rest.replace(word(pattern), () => { modes.push(mode); return " "; });
  const days = [];
  const dayPatterns = [
    ["yesterday", "вчерашн(?:ий(?:\\s+день)?|его(?:\\s+дня)?)|вчера"],
    ["today", "сегодняшн(?:ий(?:\\s+день)?|его(?:\\s+дня)?)|сегодня"],
    ["tomorrow", "завтрашний(?:\\s+день)?|завтра"],
    ["previous", "предыдущ(?:ий\\s+день|его\\s+дня)"],
    ["next", "следующий\\s+день"],
  ];
  for (const [day, pattern] of dayPatterns) rest = rest.replace(word(pattern), (_, index, input) => { days.push(day); readDirection(input, index); return " "; });
  const meals = [];
  for (const [meal, pattern] of Object.entries({ breakfast: "завтрак(?:а|у)?", lunch: "обед(?:а|у)?", dinner: "ужин(?:а|у)?", snack: "перекус(?:а|у)?" })) {
    rest = rest.replace(word(pattern), (_, index, input) => { meals.push(meal); if (!days.length) readDirection(input, index); return " "; });
  }
  rest = rest.replace(word("всю\\s+еду|все\\s+(?:блюда|продукты|позиции)|весь\\s+прием\\s+пищи|все|которые\\s+(?:здесь\\s+|тут\\s+)?есть|пожалуйста|отсюда|здесь|тут|на|в|к|мне|со?|из"), " ");
  if (days.includes("tomorrow") || days.includes("next")) return { error: "Будущие дни не поддерживаются. Можно перенести еду на вчера или скопировать её со вчера в открытый приём пищи." };
  if (missingDirection || modes.length !== 1 || days.length > 1 || meals.length > 1 || (!days.length && !meals.length) || /[^\s,.!?—–-]/u.test(rest)) {
    return { error: "Скажите одной командой, например: «Перенеси всю еду на вчера, на ужин» или «Скопируй всю еду на сегодня, на завтрак»." };
  }
  return { mode: modes[0], direction, day: days[0] ?? "selected", mealType: meals[0] ?? null };
}
